import React, { useEffect, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { confirmDialog } from 'primereact/confirmdialog';
import { Column } from 'primereact/column';
import { useLazyParams } from '../../hooks/useLazyParams';
import { InputComponent } from '../InputComponent';
import { TablaDinamica } from '../TablaDinamica';
import * as generic from '../Generico';
import { RefComercial } from '../../models/trust/proveedor/RefComercial';
import { ReferenciaComercialService } from '../../service/trust/ReferenciaComercialService';

export const ReferenciaComercial = ({ toast, id, permss, soloLectura, tipo }) => {
    const omodel = new RefComercial();
    const defaultValues = generic.funDefault(omodel.model, null);
    const [dialogCliente, setDialogCliente] = useState(false);
    const [referenciaSeleccionado, setReferenciaSeleccionado] = useState(null);
    const menuRef = useRef(null);
    const clienteSrv = new ReferenciaComercialService();
    const tablaEstado = useLazyParams({ modelo: omodel.model });
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { inText, inNumber } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) {
            loadLazyData();
        }
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams, id]);

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        _lazyParams.idp = id;
        _lazyParams.tipo = tipo;
        clienteSrv.getLista({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    };

    const openNew = () => {
        reset(defaultValues);
        setDialogCliente(true);
    };

    const hideDialog = () => setDialogCliente(false);

    const onSubmit = (data) => {
        data.idp = id;
        data.tipo = tipo;
        const request = getValues('id') == null ? clienteSrv.nuevo(data) : clienteSrv.editar(data);
        request.then(res => {
            setDialogCliente(false);
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        });
    };

    const editDeclarante = (idCliente) => {
        clienteSrv.consultar(idCliente).then(res => {
            let _cli = res.data.referencia;
            reset(generic.renewValues(_cli, omodel.model));
            setDialogCliente(true);
        });
    };

    const confirmDelete = (idCliente) => {
        confirmDialog({
            message: '¿Está seguro de eliminar la referencia?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                clienteSrv.delete(idCliente).then(res => {
                    loadLazyData();
                    generic.funcSuccess(res, toast);
                }).catch(error => generic.funcDeleteError(error, toast));
            }
        });
    };

    const itemsMenu = () => {
        if (soloLectura) {
            return [{ label: 'Opciones', items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editDeclarante(referenciaSeleccionado?.id) }] }];
        }
        return [{
            label: 'Opciones', items: [
                { label: 'Editar', icon: 'pi pi-pencil', command: () => editDeclarante(referenciaSeleccionado?.id) },
                { label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(referenciaSeleccionado?.id) }
            ]
        }];
    };

    const accionesTemplate = (rowData) => (
        <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu" aria-haspopup
            onClick={(event) => { setReferenciaSeleccionado(rowData); menuRef.current.toggle(event); }}
        />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de Referencias Comerciales
            </span>
        </div>
    );

    return (
        <div className="componente-declarante">
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />
            <Dialog visible={dialogCliente} header={getValues('id') == null ? "Nueva referencia" : "Editar referencia"} modal className="p-fluid modal-ssize dialog-personalizado" onHide={hideDialog} style={{ width: '450px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid px-2">
                        <div className="col-12 mb-3">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-shop text-primary"></i>
                                    REFERENCIAS COMERCIALES:
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>
                        {inText('establecimiento', { icon: 'pi pi-building' }, 12)}
                        {inText('direccion', { icon: 'pi pi-map-marker' }, 12)}
                        {inText('telefono', { icon: 'pi pi-phone' }, 12)}
                        {inNumber('compra_promedio', 2, true, { icon: 'pi pi-wallet', iconPosition: 'left' }, 12)}
                        <div className="col-12 mt-4 flex justify-content-end">
                            {soloLectura ? (
                                <div className="field col">
                                    <Button label="Cerrar" style={{ maxWidth: '120px' }} icon="pi pi-times" type="button" className="p-button-warning" onClick={() => hideDialog(false)} />
                                </div>
                            ) : (
                                generic.buttonsForms(hideDialog)
                            )}
                        </div>
                    </div>
                </form>
            </Dialog>
        </div>
    );
};
